<template>
  <div>
    <div
      class="header"
      v-if="
        ![
          'bistAnalysis',
          'work-history-detail',
          'workTest',
          'examination',
          'bist',
          'task',
          'practice',
          'classTest',
          'questions',
          'practiceQuestions',
          'classicQuestions',
          'errQuestions',
          'portrait',
          'user',
          'notice',
          'creatSubject',
          'bookCampusAuth',
          'bookCourse',
          'bookTextbook',
          'bookKnowledge'
        ].includes($route.name)
      "
    >
      <!-- logo区域 -->
      <div class="left">
        <img src="../assets/img/bg_logo.png" />
        <span>数刷刷智慧数学平台</span>
      </div>
      <!-- 考试界面区域 -->
      <div class="right">
        <div class="userInfo" @click="changeuser">
          <el-badge is-dot :hidden="hasNoitfy" class="item">
            <span class="userName">{{ studentInfo.studentName }}</span>
          </el-badge>
          <el-tooltip
            class="item"
            effect="dark"
            :disabled="hasNoitfy"
            content="请先到个人中心绑定邮箱"
            placement="bottom-end"
          >
            <span class="userStudentNo">学号：{{ studentInfo.studentNo }}</span>
          </el-tooltip>
        </div>
      </div>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
import { getUserInfo } from "@/util/session";
import { studentDetail } from "@/api/student";
import { IsEmptyString, validateEmail } from "@/util/stringutl";
import { mapState, mapGetters } from "vuex";
export default {
  name: "home",
  data() {
    return {
      extract: "",
      studentInfo: {},
      routeName: "",
      avataricon: {},
      email: ""
    };
  },
  computed: {
    ...mapState({
      examinationInfo: state => state.examination.examinationInfo,
      countdownTime: state => state.examination.countdownTime
    }),
    ...mapGetters(["countdown"]),
    hasNoitfy() {
      return IsEmptyString(this.email) == false && validateEmail(this.email);
    }
  },
  mounted() {
    this.avataricon = require("@/assets/img/icontouxiang.png");
    if (this.$route.name !== "creatSubject") {
      this.getStudentDetail();
    }
    this.$forceUpdate();
  },
  methods: {
    errorHandler() {
      return true;
    },
    //获取提取码
    onSubmit() {
      console.log("submit!");
    },
    changeuser() {},
    getStudentDetail() {
      this.studentInfo = JSON.parse(getUserInfo("userInfo"));
      studentDetail(this.studentInfo.studentId).then(res => {
        if (res.code == 200) {
          this.studentInfo.avatar = res.data.avatar;
          this.email = res.data.email;
          this.avataricon = res.data.avatar;
          sessionStorage.setItem("avataricon", this.avataricon);
        }
      });

      console.log("this.studentInfo", this.studentInfo);
    }
  }
};
</script>

<style scoped lang="scss">
.header {
  display: flex;
  background: #fff;
  height: 64px;
  .left {
    display: flex;
    align-items: center;
    width: 300px;
    padding: 0 24px;
    color: #006dfe;
    font-size: 24px;
    white-space: nowrap;
    font-weight: 700;
    letter-spacing: 0.5px;
    @media screen and (max-width: 1024px) {
      display: none;
    }
    @media screen and (max-width: 768px) {
      display: none;
    }
    cursor: pointer;
    border-bottom: 2px solid #f8fafb;
    img {
      width: 20px;
      height: 20px;
      margin-right: 15px;
    }
  }

  .right {
    border-bottom: 2px solid #f8fafb;
    flex-grow: 1;
    flex-direction: row-reverse;
    // align-items: center;
    display: flex;
    height: 64px;
    .userInfo {
      margin-top: 8px;
      padding-left: 20px;
      position: relative;
      display: flex;
      align-items: center;
      margin-right: 20px;
      height: 64px;
      cursor: pointer;

      .userName {
        font-weight: 600;
        font-size: 14px;
        margin-right: 15px;
      }
      .userStudentNo {
        font-size: 14px;
      }
      @media screen and (max-width: 1024px) {
        display: none;
      }
      @media screen and (max-width: 768px) {
        display: none;
      }
    }
  }
  // .examinationInfo {
  //   display: flex;
  //   .cell {
  //     display: flex;
  //     align-items: center;
  //     margin: 0 40px;
  //     .name {
  //       white-space: nowrap;
  //       margin: 0 15px;
  //     }
  //   }
  // }
}
</style>
